export const AI_CREDITS_TOOLTIP_KEY = 'premium-purchase-plan.feature_table.ai_credits_section.ai_credits_tooltip';
export const AI_CREDITS_URL = 'https://support.wix.com/article/about-ai-credits';
export const AI_CREDITS_LINK_COLOR = 'var(--wds-color-text-primary)';
export const isAiCreditsFeature = tooltipTranslationKey => tooltipTranslationKey === AI_CREDITS_TOOLTIP_KEY;
//# sourceMappingURL=aiCreditsFeature.js.map